export default {
  global: {
    body: {
      bg: 'greys.white',
      color: 'text',
      fontSize: '0.875rem',
      overflow: 'hidden',
    },
  },
}
